// Copyright 2017 The MathWorks, Inc.
/**
 * This defines a list of constants which represent the different mnemonics state of the toolstrip, maintains its current
 * mnemonics state and manages toolstrip focus depending on the current mnemonics state.
 * See the MnemonicsManager for more details.
 */

define([
    "dojo/dom-class",
    "MW/uiframework/FocusManager"
], function (domClass, FocusManager) {
    return {
        _currentMnemonicsState: undefined,
        _toolstrip: undefined,
        NULL_NULL: 1,
        NULL_CONTROL: 2,
        NULL_TAB: 3,
        CONTROL_TAB: 4,
        TAB_TAB: 5,

        getCurrentMnemonicsState: function () {
            return this._currentMnemonicsState;
        },

        setCurrentMnemonicsState: function (state, manageToolstripFocus) {
            this._currentMnemonicsState = state;

            manageToolstripFocus = (typeof manageToolstripFocus !== "undefined") ? manageToolstripFocus : true;
            if (manageToolstripFocus) {
                this._manageToolstripFocus(state);
            }
        },

        setToolstrip: function (toolstrip) {
            this._toolstrip = toolstrip;
        },

        _manageToolstripFocus: function (state) {
            if (state === this.NULL_NULL) {
                FocusManager.refuseFocus(this._toolstrip.domNode);
            } else {
                FocusManager.temporaryFocus(this._toolstrip.domNode);
            }

            domClass.toggle(document.body, "displayFocus", state !== this.NULL_NULL);
        }
    };
});